import { updateSelections } from "@/components/configurator/global-option/helper";
import { GroupParentAttributeOptionSet } from "@/components/configurator/global-option/types";
import { BodyUnitBody } from "@/utils/form-data-manager";
import {
  formDataDeepClone,
  resetGroupParentAttributeOptionSet,
} from "@/utils/helper";

export const handleEnableDisableOptions = (
  updated: any,
  selectedBody: {
    index: number;
    body: BodyUnitBody | null;
  },
  groupParentAttributeOptionSet: GroupParentAttributeOptionSet,
  setBodyGroupParentAttributeOptionSet: any,
  setInitialBodyGroupParentAttributeOptionSet: any,
  setBodiesConfirmedValuesText: any,
  setGlobalOptionsChanged: any,
  setBodies: any
) => {
  if (!groupParentAttributeOptionSet || !groupParentAttributeOptionSet.size)
    return;
  const initialValues: { [key: string]: string } = {};
  let updatedOptionSet = resetGroupParentAttributeOptionSet(
    formDataDeepClone(groupParentAttributeOptionSet)
  );
  // Generate confirmed values
  for (const [groupId, groupData] of groupParentAttributeOptionSet.entries()) {
    const selectedLabels = Array.from(groupData.parents.values())
      .flatMap((parent) =>
        parent.child.map(
          (attribute) =>
            updated.bodies[
              selectedBody.index
            ]?.global_picks_data?.global_picks.find(
              (pick: any) => pick.key === attribute.attributeCode
            )?.label
        )
      )
      .filter((label): label is string => Boolean(label?.trim()));
    initialValues[groupId] = selectedLabels.length
      ? selectedLabels.join(" | ")
      : "";
  }
  // Update selections in one pass
  if (updated.bodies[selectedBody.index]?.global_picks_data?.global_picks) {
    for (const pick of updated.bodies[selectedBody.index].global_picks_data!
      .global_picks) {
      const group = updatedOptionSet.get(pick.group_key!);
      const parent = group?.parents.get(pick.parent_name!);
      const attribute = parent?.child.find(
        (option) => option.attributeCode === pick.key
      );
      const selectedOption = attribute?.labelOptions.options.find(
        (opt) => opt.value === String(pick.value)
      );
      if (group && parent && attribute && selectedOption) {
        updatedOptionSet = updateSelections(
          updatedOptionSet,
          selectedOption,
          attribute,
          pick.parent_name!,
          pick.group_key!
        );
      }
    }
    setBodyGroupParentAttributeOptionSet(formDataDeepClone(updatedOptionSet));
    setInitialBodyGroupParentAttributeOptionSet(
      formDataDeepClone(updatedOptionSet)
    );
    // Deliberately not written to the global option set: this is one body's picks,
    // and the global dropdowns (attribute-select.tsx) would show them as disabled.
  }

  setBodiesConfirmedValuesText((prev: any) => {
    const updatedValues = [...prev];
    updatedValues[selectedBody.index] = initialValues;
    return updatedValues;
  });
  setGlobalOptionsChanged(false);
  setBodies(updated.bodies);
};

export const getParentAttributeSetKey = (
  parents: Map<any, any>,
  groupName: string
) => {
  if (!parents || !groupName) return null;

  const groupNameLower = groupName.toLowerCase();

  for (const [parentKey, parentData] of parents.entries()) {
    if (
      typeof parentKey === "string" &&
      parentKey.toLowerCase().includes(groupNameLower)
    ) {
      return parentData.parentAttributeSetKey;
    }
  }

  return parents.values().next().value?.parentAttributeSetKey;
};
